import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';
import { layout } from '../theme/tokens';

const STORAGE_KEY = 'appShell_sidebarExpanded';

const AppShellContext = createContext(null);

export function AppShellProvider({ children }) {
  const [sidebarExpanded, setSidebarExpanded] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored !== null ? JSON.parse(stored) : true;
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(sidebarExpanded));
    } catch {
      // ignore storage errors
    }
  }, [sidebarExpanded]);

  const toggleSidebar = useCallback(() => {
    setSidebarExpanded((prev) => !prev);
  }, []);

  const value = useMemo(
    () => ({
      sidebarExpanded,
      setSidebarExpanded,
      toggleSidebar,
      sidebarWidth: sidebarExpanded ? layout.sidebarWidthExpanded : layout.sidebarWidthCollapsed,
    }),
    [sidebarExpanded, toggleSidebar]
  );

  return (
    <AppShellContext.Provider value={value}>
      {children}
    </AppShellContext.Provider>
  );
}

export function useAppShell() {
  const context = useContext(AppShellContext);
  if (!context) {
    throw new Error('useAppShell must be used within AppShellProvider');
  }
  return context;
}
